import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import { userActions } from '../../../_actions/user.actions';
import Swal from 'sweetalert2';

import opptimise_logo_big from '../../../images/opptimise_logo_big.png';

import '../LoginPage/login.css';
import 'bootstrap/dist/css/bootstrap.min.css';


class ForgotPassword extends React.Component {
    constructor(props) {
        super(props);

        // reset login status
        // this.props.dispatch(userActions.logout());

        this.state = {
            email: '',
            submitted: false,
            incorrect_email: false

        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        const { dispatch } = this.props;

       
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value, incorrect_email: false });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });

        const data = {
            email: this.state.email,
        }
        if (/^[A-Za-z0-9](([_\.\+\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([\.\+\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$/.test(data.email)) {
            this.props.dispatch(userActions.forgotPassword(data, (forgot_password_data) => {
                Swal({
                    text: forgot_password_data.data.message,
                    type: 'success',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK'
                })
                .then(result => {
                    this.props.history.push('/login')
                })
            }));
        }else {
            this.setState({
                incorrect_email: true
            })
        }
    }

    render() {

        const { email, submitted, incorrect_email } = this.state;
        return (
            <div className="login-page text-white">

                <div className="text-md-left py-3  px-md-5" style={{width: 'max-content'}}>
                    <div className="d-flex justify-content-center align-items-center py-2">
                        <img src={opptimise_logo_big} style={{width: 70}} />
                    </div>
                    <h5>Behavioral Analytics</h5>
                </div>

                <div className="container pt-5">
                    <div className="d-flex flex-row justify-content-center">
                        <div className="col-lg-5 col-md-8 col-11 px-0">
                            <div className="login-field-page">
                                <p className="h4 text-center py-3 py-lg-2">Forgot Password</p>
                                {
                                    // this.props.state.forgotPasswordReducer.status === false &&
                                    <React.Fragment>
                                        <p style={{ fontSize: '14px' }} className="text-center col-12">You will recieve instructions on how to reset your password on this email ID.</p>
                                        {/* {
                                            this.props.forgotPasswordResponse !== '' &&
                                                <div className="error-message-forgot-password">
                                                    <i className="fa fa-exclamation-triangle" style={{marginRight: 10, color: 'rgb(238, 201, 9)'}}></i>
                                                    <p>{this.props.forgotPasswordResponse}</p>
                                                </div>
                                        } */}
                                        <div className="">
                                            <form
                                                method="post"
                                                onSubmit={
                                                    this.handleSubmit
                                                }
                                            >
                                                <div className="form-group">
                                                    <label htmlFor="email" className="text-uppercase"><small>EMAIL ID</small></label>
                                                    <input
                                                        type="email" className="form-control" id="email" placeholder="name@company.com"
                                                        name="email"
                                                        required
                                                        value={email}
                                                        onChange={this.handleChange}
                                                    />
                                                    {submitted && !email &&
                                                        <div className="help-block text-danger" style={{background: 'white',padding: '0.1rem 1rem', marginTop: '-5px', borderBottomLeftRadius: 10, borderBottomRightRadius: 10}}>Email is required</div>
                                                    }
                                                    {submitted && incorrect_email &&
                                                        <div className="help-block text-danger" style={{background: 'white',padding: '0.1rem 1rem', marginTop: '-5px', borderBottomLeftRadius: 10, borderBottomRightRadius: 10}}>Email should be valid!</div>
                                                    }
                                                </div>

                                                <div className="form-group">
                                                    <div className="text-center">
                                                        <Button
                                                            type="submit"
                                                            disabled={!email}
                                                            className="btn buttonColor text-white btn-sm"
                                                            style={{padding: '0.3rem 1.5rem'}}
                                                        >
                                                            <small>SEND INSTRUCTIONS</small>
                                                        </Button>
                                                        {/* {
                                                            (this.props.state.forgotPasswordReducer.status === false && this.props.state.forgotPasswordReducer.error === false) && this.state.submitted === true &&
                                                                <div style={{display: 'flex', justifyContent: 'center', padding: '20px 0 0 0'}}>
                                                                    <LoaderComp />
                                                                </div>
                                                        } */}
                                                    </div>
                                                </div>
                                                <p className="text-center "><Link className="text-white" to='/login'> <small>Back to Login</small></Link></p>

                                            </form>
                                        </div>

                                    </React.Fragment>

                                }

                                {/* {
                                    this.props.state.forgotPasswordReducer.status === true &&
                                    <React.Fragment>
                                        <p className="text-center">Please check your mail for instructions </p>
                                        <div className="text-center">
                                            <Link to='/login' className="btn btn-sm text-white buttonColor">BACK TO LOGIN</Link>
                                        </div>
                                    </React.Fragment>
                                } */}

                            </div>
                        </div>
                    </div>

                </div>


            </div>
        );
    }
}

function mapStateToProps(state) {
  

    return {
      state
    };
}

const connectedForgotPassword = connect(mapStateToProps)(ForgotPassword);
export { connectedForgotPassword as ForgotPassword }; 


// WEBPACK FOOTER //
// ./src/_components/common/ForgotPassword/index.jsx